/*
 * $Id:: userAreaTheme.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const theme = {
    breakpoints: {
        keys: ['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    palette: {
        primary: {
            main: '#4D4D4D',
        },
        secondary: {
            main: '#4D4D4D',
        },
        status: {
            warning: '#ff0000',
        },
        error: {
            main: '#D32F2F',
            border: '#F44336',
            label: '#B71C1C',
        },
        disabled: {
            main: '#191a1a',
            button: '#BDBDBD',
        },
        text: {
            tintGreen: '#E2EFD5',
            primary: '#ECEFF1',
            outlined: '#546E7A',
            mainBlue: '#1976D2',
            darkBlue: '#0D47A1',
            linkBlue: '#1E88E5',
            listgrey: '#616161',
            chipgrey: '#5D5D5D',
            tabgrey: '#78909C',
            label: '#212121',
            value: '#757575',
            tableValue: '#171C26',
            inactiveChildGrey: '#858585',
            detailsGrey: '#303233',
            gridDetailTitle: '#272833',
            gridDetailValue: '#858585',
            lightBg: '#F1F2F5',
            darkGrey: '#6B6C7E',
            statusGreen: '#388E3C',
            blueGray: '#607D8B',
            mainGreen: '#3F5E20',
            darkGreen: '#223211',
            searchGreen: '#15350D',
            tableHeaderGrey: '#2E2E2E',
            primaryLight: '#D2E8BC',
        },
        scrollbar: {
            main: '#B8B8B8',
            green: '#386B15',
        },
        svg: {
            main: '#3F5E20',
        },
        action: {
            dimGrey: '#B0BEC5',
            activeBlue: '#1565C0',
            footerWhite: '#FBFBFB',
            footerGrey: '#5D5D5D',
        },
        tab: {
            selected: '#135FA5',
        },
        paginator: {
            main: '#6B6C7E',
        },
        image: {
            background:
                'linear-gradient(45deg, #e7e7ed 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e7e7ed 75%), linear-gradient(45deg, transparent 75%, #e7e7ed 75%), linear-gradient(45deg, #e7e7ed 25%, transparent 25%)',
        },
    },
    spacing: 8,
    typography: {
        useNextVariants: true,
        htmlFontSize: 16,
        fontFamily: '"Open Sans", sans-serif',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        titleFontSize: '1.25rem',
        titleFontWeight: 600,
        titleLetterSpace: '0.4px',
        h1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 10,
            fontSize: '5.973rem',
            lineHeight: '130px',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 300,
            fontSize: '3.733rem',
            lineHeight: '81px',
            letterSpacing: '-0.5px',
        },
        h3: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '2.962rem',
            lineHeight: '65px',
            letterSpacing: '0em',
        },
        h4: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '2.098rem',
            lineHeight: '46px',
            letterSpacing: '0.25px',
        },
        h5: {
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '1.481rem',
            lineHeight: '32px',
        },
        h6: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '1.234rem',
            lineHeight: '27px',
            letterSpacing: '0.25px',
        },
        subtitle1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '0.988rem',
            lineHeight: '24px',
            letterSpacing: '0.15px',
        },
        subtitle2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 500,
            fontSize: '0.864rem',
            lineHeight: '24px',
            letterSpacing: '0.1px',
        },
        body1: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '0.988rem',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            color: '#3F5E20',
        },
        body2: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '0.864rem',
            lineHeight: '20px',
            letterSpacing: '0.25px',
        },
        button: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '0.875rem',
            lineHeight: '20px',
            // letterSpacing: '1.25px',
            textTransform: 'initial',
            color: 'rgba(0,0,0,0.87)',
        },
        caption: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 600,
            fontSize: '0.75rem',
            lineHeight: '17px',
            letterSpacing: '0.41px',
            backgroundColor: '#424242',
            color: '#ffffff',
        },
        overline: {
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: '16px',
            letterSpacing: '2.03px',
            textTransform: 'uppercase',
            color: 'rgba(0,0,0,0.6)',
        },
    },
};

export default {
    ...theme,
    // props: {
    //     MuiButtonBase: {
    //         disableRipple: true,
    //     },
    // },
    overrides: {
        MuiButton: {
            root: {
                padding: '10px',
                // backgroundColor: theme.palette.primary.main,
                color: theme.palette.text.primary,
                height: '40px',
                margin: '5px',
                minWidth: '25px',
                fontFamily: theme.typography.button.fontFamily,
                fontSize: theme.typography.button.fontSize,
            },

            contained: {
                border: '1px solid ' + theme.palette.text.mainBlue,
                backgroundColor: theme.palette.text.mainBlue,
                color: theme.palette.text.primary,
                boxShadow: 'none',
                padding: '10px',
                '&:hover': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: theme.palette.text.mainBlue,
                    '@media': {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                },
                '&:active': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: theme.palette.text.mainBlue,
                },
                // Contained Button - Warning
                '&.warning': {
                    color: theme.palette.text.primary,
                    borderColor: theme.palette.error.border,
                    '&:hover': {
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                    '&:active': {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.text.mainBlue,
                    },
                },

                '&$disabled': {
                    backgroundColor: theme.palette.disabled.button,
                    border: 'none',
                    color: '#FFFFFF',
                },

                // Contained Button - medium Size

                '&.mediumSize': {
                    height: '36px',
                },

                //-----------------------------------MENU BUTTON---------------------------------------

                '&.menuButton': {
                    height: '30px',
                    width: '109px',
                    border: '1px solid #D6D6D6',
                    backgroundColor: '#F9F9F9',
                    fontSize: '0.863rem',
                    letterSpacing: '1.25px',
                    lineHeight: '19px',
                    textAlign: 'center',
                },
                //------------------------------------------------------------------------------------
            },
            outlined: {
                border: '1px solid ' + theme.palette.text.mainGreen,
                color: theme.palette.text.mainGreen,
                padding: '0px 8px',
                '&:hover': {
                    borderColor: theme.palette.text.mainGreen,
                    backgroundColor: 'transparent',
                },
                '&:active': {
                    boxShadow: 'none',
                    borderColor: theme.palette.text.mainGreen,
                    backgroundColor: 'transparent',
                },
                // Outlined Button - Warning
                '&.warning': {
                    color: theme.palette.error.border,
                    borderColor: theme.palette.text.mainBlue,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&:active': {
                        boxShadow: 'none',
                        backgroundColor: 'transparent',
                    },
                },

                // Outlined Button - medium Size

                '&.mediumSize': {
                    height: '36px',
                },

                //-----------------------------------MENU BUTTON---------------------------------------

                '&.menuButton': {
                    height: '30px',
                    width: '109px',
                    border: '1px solid #D6D6D6',
                    backgroundColor: '#F9F9F9',
                    fontSize: '0.863rem',
                    letterSpacing: '1.25px',
                    lineHeight: '19px',
                    textAlign: 'center',
                },
                //------------------------------------------------------------------------------------
            },
            // Outlined Button - Primary
            outlinedPrimary: {
                color: theme.palette.text.primary,
                borderColor: theme.palette.text.mainBlue,
                '&:hover': {
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },

                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                },
                // Outlined Button - Primary - Medium Size

                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success
            outlinedSecondary: {
                borderColor: theme.palette.text.mainBlue,
                color: theme.palette.text.primary,
                '&:hover': {
                    borderColor: theme.palette.text.mainBlue,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                },

                // Outlined Button - Success - Medium Size

                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success - Large Size

            outlinedSizeLarge: {
                height: '42px',
            },

            text: {
                padding: '10px',
                color: theme.palette.text.mainBlue, //text.listgrey,
            },
        },

        MuiIconButton: {
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
        },
        MuiButtonGroup: {
            grouped: {
                margin: '0px',
                marginTop: '10px',
                marginLeft: '0px',
            },
        },

        MuiInput: {
            underline: {
                '&:before': {
                    content: '',
                },
                '&:after': {
                    content: '',
                },
            },
        },

        MuiFormLabel: {
            root: {
                '&.Mui-error': {
                    color: theme.palette.error.label,
                },
            },
        },

        MuiInputBase: {
            root: {
                color: theme.palette.text.chipgrey,
                height: '24px',
                width: '265px',
                fontFamily: 'Open Sans',
                fontSize: '0.875rem',
                border: '1px solid #9B9B9B',
                borderRadius: '4px',
                letterSpacing: '-0.2px',
                '& input::placeholder': {
                    fontSize: '0.875rem',
                    fontFamily: '"Open Sans Regular", sans-serif',
                },
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused': {
                    borderColor: theme.palette.primary.main,
                },
                '&.Mui-error': {
                    borderColor: theme.palette.error.main,
                },
                '& input::-ms-clear, input::-ms-reveal': {
                    display: 'none',
                },
            },

            input: {
                marginLeft: '6px',
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        MuiAppBar: {
            root: {
                height: '65px',
                '& .MuiButton-root': {
                    color: theme.palette.primary.main,
                },
                '& .MuiButtonBase-root': {
                    // margin: '0 20px',
                },
                '& .MuiIconButton-root': {
                    height: '32px',
                    width: '32px',
                    padding: '0',

                    '& .MuiIconButton-label': {
                        height: '32px',
                        width: '32px',

                        '& .MuiSvgIcon-root': {
                            height: '32px',
                            width: '32px',

                            '& path': {
                                height: '32px',
                                width: '32px',
                            },
                        },
                    },
                },
                '& .right': {
                    marginLeft: 'auto',
                    marginRight: 0,
                },
            },
        },

        MuiDialog: {
            paper: {
                width: '520px',
                padding: '30px',
                boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1), 0px 1px 18px rgba(0, 0, 0, 0.02), 0px 6px 10px rgba(0, 0, 0, 0.04)',
                borderRadius: '3px',
                '@media (max-width:600px)': {
                    padding: '15px',
                },
            },
        },

        MuiBackdrop: {
            root: {
                backgroundColor: 'rgba(97, 97, 97, 0.8)', // base color is #616161
                // opacity: '0.8',
            },
        },
        MuiDialogTitle: {
            root: {
                color: '#000000',
            },
        },
        MuiDialogContentText: {
            root: {
                color: '#000000',
            },
        },
        MuiTypography: {
            colorError: {
                color: theme.palette.error.main,
            },
        },

        MuiRadio: {
            root: {
                color: theme.palette.text.mainBlue,
            },
            colorSecondary: {
                '&$checked': {
                    color: theme.palette.text.mainBlue,
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },

        MuiFormControlLabel: {
            label: {
                color: theme.palette.text.mainBlue,
                fontWeight: theme.typography.titleFontWeight,
                fontSize: theme.typography.titleFontSize,
            },
        },

        MuiPopover: {
            paper: {
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiListItem: {
            root: {
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: '16px',
            },
        },
        MuiListItemText: {
            root: {
                marginTop: 0,
                marginBottom: 0,
            },
            primary: {
                fontSize: '0.75rem',
                letterSpacing: 'normal',
                color: theme.palette.text.listgrey,
            },
        },

        MuiChip: {
            root: {
                color: theme.palette.text.chipgrey,
                borderRadius: '50px',
                transition: 'none',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04)',
            },
            clickable: {
                '&:hover': {
                    backgroundColor: '#FFFFFF',
                },
                '&:focus': {
                    backgroundColor: '#FFFFFF',
                },
            },
            icon: {
                marginLeft: '10px',
            },
        },

        MuiSelect: {
            select: {
                '&:focus': {
                    backgroundColor: 'transparent',
                },
            },
            icon: {
                top: 'calc(50% - 8px)',
                right: '10px',
            },
        },

        MuiCheckbox: {
            colorSecondary: {
                '&$checked': {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
            },
        },

        MuiTabs: {
            root: {
                '@media (max-width:960px)': {
                    display: 'inline-grid',
                },
            },
            indicator: {
                backgroundColor: theme.palette.text.darkGreen,
            },
            scroller: {
                overflowX: 'auto !important',
                flexWrap: 'wrap',
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.green,
                },
            },
        },
        MuiTab: {
            root: {
                fontWeight: 'normal',
            },
            textColorPrimary: {
                color: theme.palette.text.mainGreen,
                '&$selected': {
                    fontWeight: '600',
                    color: theme.palette.text.darkGreen,
                },
            },
        },

        MuiCard: {
            root: {
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04);',
                borderRadius: '5px',
            },
        },

        MuiCardContent: {
            root: {
                padding: '10px',
                '&:last-child': {
                    paddingBottom: '10px',
                },
            },
        },
        MuiTableContainer: {
            root: {
                '&::-webkit-scrollbar': {
                    width: '5px',
                    height: '5px',
                },
                '&::-webkit-scrollbar-thumb': {
                    borderRadius: '3px',
                    backgroundColor: theme.palette.scrollbar.main,
                },
            },
        },
        MuiTableHead: {
            root: {
                background: 'rgba(226, 228, 233, 0.1)',
                borderTopLeftRadius: '5px',
                borderTopRightRadius: '5px',
                borderBottom: 'solid 1px #E7E7ED',
            },
        },
        MuiTableCell: {
            root: {
                padding: '0 10px',
                color: theme.palette.text.tableValue,
                width: '100%',
            },
            head: {
                height: '38px',
                color: theme.palette.text.tableValue,
                fontSize: '0.625rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
                '&:first-child': {
                    borderTopLeftRadius: '5px',
                },
                '&:last-child': {
                    borderTopRightRadius: '5px',
                },
                '& .MuiTableSortLabel-root': {
                    color: theme.palette.text.tableValue,
                },
                '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
                    color: theme.palette.text.tableValue,
                },
            },
            body: {
                '& .generalBtn': {
                    color: '#086B9C',
                    fontSize: '0.75rem',
                    textDecoration: 'underline',
                    '&:focus-visible': {
                        backgroundColor: 'rgba(209, 224, 194, 0.2)',
                        outline: 'none',
                        border: '2px dashed #4F7E1D',
                        borderRadius: '3px',
                    },
                },
                color: theme.palette.text.tableValue,
                height: '64px',
                '& h3.two_rows': {
                    maxHeight: '33.6px',
                    lineClamp: '2',
                },
                '& h3.three_rows': {
                    maxHeight: '50px',
                    lineClamp: '3',
                },
                '& h3': {
                    display: 'block',
                    // eslint-disable-next-line no-dupe-keys
                    display: '-webkit-box',
                    maxWidth: '194px',
                    margin: '0 auto',
                    fontSize: '0.75rem',
                    lineHeight: '1.4',
                    boxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontWeight: 'normal',
                },
            },
        },
        MuiTablePagination: {
            root: {
                marginTop: '1rem',
                color: theme.palette.paginator.main,
                '& .MuiTypography-body2': {
                    fontWeight: '600',
                },
                '& .MuiInputBase-root': {
                    border: 'none',
                    width: 'auto',
                },
                '& .MuiSelect-icon': {
                    top: 'calc(50% - 14px)',
                    right: '0px',
                },
                '& .MuiSelect-root': {
                    fontWeight: '600',
                },
            },
        },

        MuiSnackbar: {
            root: {
                '&.MuiSnackbar-anchorOriginTopRight': {
                    top: '110px',
                    right: '40px',
                },
            },
        },
        MuiAlert: {
            root: {
                display: 'flex',
                alignItems: 'center',
                minHeight: '32px',
                minWidth: '200px',
                maxWidth: '500px',
                '&.MuiAlert-filledInfo': {
                    backgroundColor: theme.palette.text.mainBlue,
                    fontWeight: '600',
                    fontSize: '0.875rem',
                },
                '& .MuiIconButton-root': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
                '& .MuiAlert-icon': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
                '& .MuiAlert-message': {
                    paddingTop: '0',
                    paddingBottom: '0',
                },
            },
        },
        MuiDrawer: {
            paper: {
                backgroundColor: '#FAFAFA',
                padding: '30px 15px',
                '@media (max-width: 960px)': {
                    padding: '30px 0px 30px 0px',
                },
            },
        },
        MuiPaginationItem: {
            root: {
                color: '#15350D',
                borderRadius: '4px',
                margin: '0 1px',
            },
        },
        MuiTooltip: {
            tooltip: {
                maxWidth: '250px',
                lineHeight: '133%',
                fontWeight: 400,
                backgroundColor: '#F3F8EF',
                opacity: '.9',
                color: '#2E2E2E',
                fontStyle: 'normal',
                fontSize: '0.75rem',
                border: '1px solid #B3CC9A',
                borderRadius: '4px',
                padding: '10px 12px',
            },
            arrow: { color: '#F3F8EF' },
            tooltipPlacementTop: {
                right: '1px',
                top: '13px',
            },
        },
    },
};
